// #region CONSTANTES
export const RESSOURCE_SERVICE_TYPE = "service_types";
export const RESSOURCE_UNITE_TYPES = "unite_types";
export const RESSOURCE_ZONE = "zones";
// #endregion


